import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { AlertsModalType, useAlertsModalContext } from '../../context';
import { useDeleteWebhook } from '../../hooks/useDeleteWebhook';
import { EditOrDeleteWebhookModalProps } from '../../types';

export const DELETE_WEBHOOK_MODAL_TEST_ID = 'delete-webhook-modal';
export const DELETE_WEBHOOK_BUTTON_TEST_ID = 'delete-webhook-button';

export const DeleteWebhookModal = ({ webhookId }: EditOrDeleteWebhookModalProps) => {
  const { closeModal } = useAlertsModalContext();
  const { deleteWebhook, isLoading } = useDeleteWebhook(() =>
    closeModal(AlertsModalType.DeleteWebhookModal),
  );
  const variables = { id: webhookId };

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(AlertsModalType.DeleteWebhookModal)}
      id={DELETE_WEBHOOK_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete webhook?</ModalHeader>

      <ModalBody>
        Are you sure you want to delete this webhook? You’ll need to reconfigure this webhook to
        receive notifications at this endpoint in the future.
      </ModalBody>

      <ModalFooter>
        <DestructiveButton
          data-test={DELETE_WEBHOOK_BUTTON_TEST_ID}
          isLoading={isLoading}
          onClick={() => deleteWebhook({ variables })}
          size={BUTTON_SIZES.LARGE}
        >
          Delete webhook
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
